import React from "react";
import styled from "styled-components";
import { BarChart } from "@mui/x-charts/BarChart";

const Wrap = styled.div`
    background-color: #FFFFFF; border: 1px solid #EFEFEF;
    border-radius: 12px; padding: 16px;
    .h { color: #25368D; font-size: 15px; font-weight: 600; margin-bottom: 12px; }
    .empty { color: #838BB4; padding: 40px 0; text-align: center; font-size: 13px; }
`;

export default function BreakdownChart({ title, data, labelKey }) {
    const rows = data || [];
    if (!rows.length) return <Wrap><div className="h">{title}</div><div className="empty">ไม่มีข้อมูล</div></Wrap>;
    const labels = rows.map(r => String(r[labelKey] ?? "-"));
    const subs   = rows.map(r => r.submissions);
    const atts   = rows.map(r => r.attendances);
    return (
        <Wrap>
            <div className="h">{title}</div>
            <BarChart
                height={260}
                xAxis={[{ data: labels, scaleType: "band" }]}
                series={[
                    { data: subs, label: "Submissions", color: "#25368D" },
                    { data: atts, label: "Attendances", color: "#FBE250" },
                ]}
                margin={{ left: 40, right: 16, top: 30, bottom: 60 }}
            />
        </Wrap>
    );
}
